import DOMPurify from 'dompurify';
import { canUseDOM } from 'exenv';

if (canUseDOM) {
  DOMPurify.addHook('afterSanitizeAttributes', node => {
    if (node.tagName.toLowerCase() === 'a') {
      var href = node.getAttribute('href') || '';
      var rel = 'noopener noreferrer';

      if (href !== null && href !== void 0 && href.startsWith('tel') || href.includes('mailto')) {
        rel += ' nofollow';
      }

      node.setAttribute('target', '_blank');
      node.setAttribute('rel', rel);
    }
  });
}

export var ALLOWED_TAGS = ['a', 'b', 'br', 'div', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'i', 'li', 'ol', 'p', 'strong', 'span', 'sup', 'ul'];
export var getReactHtmlObject = text => ({
  // NOTICE: DOMPurify is a DOM-only, super-fast, uber-tolerant XSS sanitizer,
  // so please make sure this works in our EFI server too by checking the env first.
  __html: canUseDOM ? DOMPurify.sanitize(text, {
    ALLOWED_TAGS,
    // from https://github.com/cure53/DOMPurify#can-i-configure-dompurify; search for ALLOWED_URI_REGEXP
    ALLOWED_URI_REGEXP: /^(?:(?:http|https|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
    ALLOWED_ATTR: ['data-test-id', 'data-testid', 'style', 'href', 'target', 'rel', 'src', 'alt', 'width', 'height']
  }) : text
});